import type { part } from "@/api/supplierService";
import { Box, Typography, Chip, Divider, useTheme } from "@mui/material";

interface BreakdownInfoProps {
  partInfo?: part;
  version: "v1" | "v2";
}

const BreakdownInfo = ({ partInfo, version }: BreakdownInfoProps) => {
  const theme = useTheme();
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Box display="flex" alignItems="center" gap={1}>
        <Typography
          color={theme.palette.grey[500]}
          fontSize="1.2rem"
          fontWeight={600}
        >
          Part Number :{" "}
          <span style={{ color: "black" }}>{partInfo?.part_number || "-"}</span>
        </Typography>
        <Chip
          sx={{ ml: 1 }}
          label={version === "v1" ? "Version 1" : "Version 2"}
          color={version === "v2" ? "primary" : "secondary"}
          size="small"
        />
        {version === "v1" && (
          <Chip label="View Only" color="error" size="small" />
        )}
      </Box>
      <Typography
        color={theme.palette.grey[500]}
        fontSize="1.2rem"
        fontWeight={600}
      >
        Part Name :{" "}
        <span style={{ color: "black" }}>{partInfo?.part_name || "-"}</span>
      </Typography>
      <Box display="flex" gap={2}>
        <Typography
          color={theme.palette.grey[500]}
          fontSize="1.2rem"
          fontWeight={600}
        >
          AC : <span style={{ color: "black" }}>{partInfo?.ac || "-"}</span>
        </Typography>
        <Divider orientation="vertical" flexItem />
        <Typography
          color={theme.palette.grey[500]}
          fontSize="1.2rem"
          fontWeight={600}
        >
          Routing :{" "}
          <span style={{ color: "black" }}>{partInfo?.rt || "-"}</span>
        </Typography>
      </Box>
    </Box>
  );
};

export default BreakdownInfo;
